<div
  [class]="
    'popover-container ' +
    PopoverPositionEnum.anchorClassName(
      popoverRef.popoverData.preferredPosition,
      popoverRef.overlay,
      popoverRef.popoverData.origin
    )
  "
  [@fadeAnimation]="{ value: animationState, params: { fadeIn: configData.animationFadeIn } }"
>
  @if (componentContent) {
    <ng-container *ngComponentOutlet="componentContent"></ng-container>
  } @else if (templateRefContent) {
    <ng-container *ngTemplateOutlet="templateRefContent; context: context"></ng-container>
  } @else {
    <div [innerHTML]="content"></div>
  }
</div>
